"use strict";
import { Path } from "react-art";
import relativeEventPosition from "./relative_event_position";
const utils = {
  midPoint(p1, p2) {
    return p1.mix(p2);
  },
  diff(p1, p2) {
    return p1.subtract(p2);
  },
  direction(p1, p2) {
    return p2.subtract(p1).normalize();
  },
  distance(p1, p2) {
    return p1.subtract(p2);
  },
  // The cast is unavoidable: @types/react@0.14 declares `nativeEvent` as the base DOM
  // `Event`, so it carries no coordinates as far as the compiler is concerned. The
  // union at least pins down what callers may hand in.
  relMouseCoords(event, node) {
    const nativeEvent = "nativeEvent" in event ? event.nativeEvent : event;
    return relativeEventPosition(nativeEvent, node);
  },
  makeArtListener: function(f) {
    return {
      handleEvent: f
    };
  },
  getRectPointsBetween: function(p1, p2, width) {
    const v = utils.diff(p1, p2);
    const p = {
      // perpendicular
      x: v.y,
      y: -v.x
    };
    const l = v.length();
    const r = width / l / 2;
    const np = {
      // normalised perpendicular
      x: p.x * r,
      y: p.y * r
    };
    const cs = [
      // corners
      { x: p1.x + np.x, y: p1.y + np.y },
      { x: p1.x - np.x, y: p1.y - np.y },
      { x: p2.x - np.x, y: p2.y - np.y },
      { x: p2.x + np.x, y: p2.y + np.y }
    ];
    return cs;
  },
  getRectPathBetween(p1, p2, width) {
    const cs = utils.getRectPointsBetween(p1, p2, width);
    return new Path().moveTo(cs[0].x, cs[0].y).lineTo(cs[1].x, cs[1].y).lineTo(cs[2].x, cs[2].y).lineTo(cs[3].x, cs[3].y).close();
  },
  drawLine(p1, p2) {
    return new Path().moveTo(p1.x, p1.y).lineTo(p2.x, p2.y).close();
  },
  drawCenteredCircle(p, radius) {
    const offset = {
      x: radius,
      y: 0
    };
    const [p1, p2] = [p.subtract(offset), p.add(offset)];
    return utils.drawCircle(p1, p2);
  },
  drawCircle(p1, p2) {
    const v = utils.diff(p1, p2);
    const radius = v.length() / 2;
    return new Path().moveTo(p1.x, p1.y).arc(-v.x, -v.y, radius, radius).arc(v.x, v.y, radius, radius).close();
  },
  Colors: {
    transparent: "rgba(0,0,0,0)"
  }
};
export default utils;
